import { IPortfolioDistributionItem, IPortfolioDistributionItemLevel2 } from "../../../../services/ManagedPortfolioService";
import { TDiversCartTipoActivo1RiesgoModel, TDiversCartTipoActivo1y2RiesgoModel } from "../types/DiversificacionCarteraTypes";



type TFormatCircleGraphDataProps = {
    activo1: TDiversCartTipoActivo1RiesgoModel[];
    activo1y2: TDiversCartTipoActivo1y2RiesgoModel[];
};

export const FormatCircleGraphData = ( { activo1, activo1y2 } : TFormatCircleGraphDataProps) => {

    const dataCircle: IPortfolioDistributionItem[] = []

    for (let i: number = 0; i < activo1.length; i++) {
        const dataLevel2: IPortfolioDistributionItemLevel2[] = []
        for (let j: number = 0; j < activo1y2.length; j++) {
            if (activo1y2[j].tipoActivo1 === activo1[i].tipoActivo1) {
                dataLevel2.push({
                    name: activo1y2[j].tipoActivo2,
                    value: activo1y2[j].riesgo
                })
            }
        }
        dataCircle.push(
            {
                name: activo1[i].tipoActivo1,
                value: activo1[i].riesgo,
                level2: dataLevel2.length > 0 ? dataLevel2 : undefined
            }
        ) 
    };
    
    return dataCircle;
};